import React from "react";
import styled from "styled-components";
import { imageUrl, isMobile } from "../../helpers/ApplicationHelper";
import GA from "../../lib/ga";

export const PromotionBannerHeightNumber = 85;
export const PromotionBannerHeightMobileNumber = 90;
export const PromotionBannerHeight = `${PromotionBannerHeightNumber}px`;
export const PromotionBannerHeightMobile = `${PromotionBannerHeightMobileNumber}px`;

export const PromotionBtnLink = "https://vip.worthy.com/bf-24/";
export const PromotionSessionStorageKey = "promotionBannerClosed";

const Banner = styled.div`
    color: black;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    font-family: "Roboto";
    z-index: 5;
    box-sizing: border-box;
    height: ${PromotionBannerHeight};
    background-image: url(${(props) =>
        props.mobile
            ? imageUrl("banners/mobile.jpg")
            : imageUrl("banners/desktop.jpg")});
    align-self: stretch;
    background-color: white;
    background-position-y: center;
    background-position-x: ${(props) => (props.mobile ? "left" : "center")};
    background-size: cover;
    text-align: center;
    ${(props) =>
        props.mobile && `height: ` + PromotionBannerHeightMobile + `;`};
`;

const CloseButton = styled.button`
    position: absolute;
    top: -5px;
    bottom: 0;
    color: #ffff;
    margin: auto;
    right: 15px;
    width: 20px;
    height: 20px;
    padding: 0;
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    line-height: 0;
    font-weight: 100;
    ${(props) => props.mobile && `top: -50px;`};
`;

const RunningTextBanner = styled.span`
    color: #ffff;
    font-size: 28px;
    font-weight: 500;
    line-height: 30.8px;
    word-wrap: "break-word";

    ${(props) =>
        props.mobile &&
        `
         line-height: 24px;
         font-size: 20px;`};
`;

const RunningCaptionBanner = styled.span`
    color: #ffff;
    font-size: 15px;
    font-weight: 300;
    line-height: 21px;
    word-wrap: "break-word";
    position: absolute;
    right: 65px;
    bottom: 26px;
    ${(props) =>
        props.mobile &&
        `
        bottom: 5px;
        right: 20px;
         line-height: 21px;
         font-size: 12px;`};
`;

const RunningSubtitleBanner = styled.span`
    color: #ffff;
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;
    word-wrap: "break-word";

    ${(props) =>
        props.mobile &&
        `line-height: 21px;
      font-size: 15px;`};
`;

const TextContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 140px;
    height: 100%;
    gap: 10px;
    ${(props) =>
        props.mobile &&
        `margin-right: 100px;flex-direction: row;
        align-items: center;margin: 5px;height: unset;gap: 0px;justify-content: space-around;`};
`;

const TextInnerContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    ${(props) =>
        props.mobile &&
        `flex-direction: column;gap: 0px;justify-content: start;
  text-align: left;align-items: normal;padding: 5px 30px;`};
`;

const PromotionBtn = styled.button`
    border: none;
    padding: 8px 24px;
    height: 42px;
    border-radius: 6px;
    font: 500 16px Roboto;
    background-color: #ffff;
    background-position: center;
    transition: background 0.6s;
    color: #000;
    margin-right: 14px;
    cursor: pointer;
    text-wrap: nowrap;

    &:hover {
        background: #fffc;
        transition: background 0.4s;
    }

    &:active {
        background: #fffc;
        transition: background 0s;
    }

    ${(props) =>
        props.mobile &&
        `min-width: 0;
        font-size: 16px;
        padding: 0px 12px;
        margin-right: 30px;
        max-height: 33px;
  `};
`;

export class PromotionBanner extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
    }

    render() {
        const {
            title,
            btnText,
            sessionStorageItemName,
            clickClb,
            closeClb,
            subtitle,
            caption,
        } = this.props;

        const handleClick = () => {
            GA.promotionBannerEventCallback();
            clickClb && clickClb();
        };

        const handleBannerClose = () => {
            GA.promotionBannerClosedEvent(btnText);
            sessionStorage.setItem(sessionStorageItemName, "true");
            closeClb && closeClb();
        };

        return (
            <Banner
                id={"promotion-banner"}
                mobile={this.isMobile ? this.isMobile : undefined}
            >
                <TextContainer
                    mobile={this.isMobile ? this.isMobile : undefined}
                >
                    <TextInnerContainer
                        mobile={this.isMobile ? this.isMobile : undefined}
                    >
                        {(subtitle && (
                            <RunningSubtitleBanner
                                mobile={
                                    this.isMobile ? this.isMobile : undefined
                                }
                            >
                                {subtitle}
                            </RunningSubtitleBanner>
                        )) || <></>}
                        <RunningTextBanner
                            mobile={this.isMobile ? this.isMobile : undefined}
                        >
                            {title}
                        </RunningTextBanner>
                    </TextInnerContainer>
                    {(btnText && (
                        <PromotionBtn
                            onClick={handleClick}
                            mobile={this.isMobile ? this.isMobile : undefined}
                        >
                            {btnText}
                        </PromotionBtn>
                    )) || <></>}
                </TextContainer>
                {(caption && (
                    <RunningCaptionBanner
                        mobile={this.isMobile ? this.isMobile : undefined}
                    >
                        {caption}
                    </RunningCaptionBanner>
                )) || <></>}
                <CloseButton
                    onClick={handleBannerClose}
                    mobile={this.isMobile ? this.isMobile : undefined}
                >
                    ×
                </CloseButton>
            </Banner>
        );
    }
}

export default PromotionBanner;
